// extracted by mini-css-extract-plugin
export default {"captcha":"_-web-client-js-react-components-___Captcha-module__captcha___e4UpS","error":"_-web-client-js-react-components-___Captcha-module__error___AZzl8"};